import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React from "react";
import {
  Datagrid,
  Filter,
  FunctionField,
  ReferenceField,
  ResourceContextProvider,
  RowClickFunction,
  SearchInput,
  ShowProps,
  TextField,
} from "react-admin";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import { SchoolIdSelected } from "utils/tools";
import { StyledList } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const SharedStudent = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/students/${id}/show?parentId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Students</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="students">
          <StyledList
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              ParentId: Number(props.id),
              IsMain: false,
              SchoolId: Number(SchoolIdSelected()),
            }}
            bulkActionButtons={false}
            title=" "
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick={rowClick}>
              <FunctionField
                label="Student Info"
                render={() => (
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Id :
                      </Typography>
                      <TextField source="id" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Name :
                      </Typography>
                      <FunctionField
                        render={(record: any) =>
                          `${record.firstName} ${record.lastName}`
                        }
                        emptyText="-"
                      />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Gender :
                      </Typography>
                      <TextField source="gender" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Birthday :
                      </Typography>
                      <CustomDateField source="dateOfBirth" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        School :
                      </Typography>
                      <ReferenceField
                        source="schoolId"
                        reference="schools"
                        emptyText="-"
                        link={false}
                      >
                        <TextField source="name" emptyText="-" />
                      </ReferenceField>
                    </Grid>
                  </SanitizedGrid>
                )}
              />
              <StatusField source="status" />
              <CustomDateField
                source="createdAt"
                label="Created On"
                emptyText="-"
                isDateTime
              />
            </Datagrid>
          </StyledList>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default SharedStudent;
